import angular from 'angular';
import { AngularServices } from '../../../../modules/core';
import * as webrtc from '../../../../modules/webrtc';
import { RootScopeEvents } from '../../../../common/services/root-scope-types';
export class WebrtcConnectionStatsCollector {
    /* @ngInject */
    constructor($rootScope, VideoProviderFactory, $log) {
        this.$rootScope = $rootScope;
        this.VideoProviderFactory = VideoProviderFactory;
        this.$log = $log;
        this.sessions = {};
        this.RETRY_ATTEMPTS = 5;
        this.RETRY_DELAY = 1000;
        $rootScope.$on(RootScopeEvents.SESSION.PUBLISHER_STREAM_CREATED, () => {
            this.collectPublisherStats();
        });
        $rootScope.$on(RootScopeEvents.SUBSCRIBER.CREATED, async (_, subscriber) => {
            this.collectSubscriberStats(subscriber);
        });
    }
    getSessionStats(sessionId) {
        if (!this.sessions[sessionId]) {
            this.sessions[sessionId] = {};
        }
        return this.sessions[sessionId];
    }
    deleteSessionStats(sessionId) {
        delete this.sessions[sessionId];
    }
    async collectSubscriberStats(subscriber) {
        const sessionId = subscriber.session.sessionId;
        const sessionStats = this.getSessionStats(sessionId);
        if (sessionStats.subscriber) {
            return;
        }
        try {
            sessionStats.subscriber = webrtc.extractConnectionStats(await subscriber.getRtcStatsReport());
        }
        catch (error) {
            this.handleError('collectSubscriberStats', error);
        }
    }
    async collectPublisherStats(attempts = this.RETRY_ATTEMPTS) {
        if (attempts === 0) {
            return;
        }
        const publisher = this.VideoProviderFactory.activeProvider.getPublisher();
        if (!publisher || !publisher.session) {
            setTimeout(this.collectPublisherStats.bind(this, --attempts), this.RETRY_DELAY);
            return;
        }
        const sessionStats = this.getSessionStats(publisher.session.sessionId);
        if (sessionStats.publisher) {
            return;
        }
        try {
            const publisherReports = await publisher.getRtcStatsReport();
            for (const { rtcStatsReport } of publisherReports) {
                const connectionStats = webrtc.extractConnectionStats(rtcStatsReport);
                if (connectionStats) {
                    sessionStats.publisher = connectionStats;
                    return;
                }
            }
        }
        catch (error) {
            // Only warn on final retry attempt to reduce log noise
            const isLastAttempt = attempts === 1;
            this.handleError('collectPublisherStats', error, isLastAttempt);
        }
        setTimeout(this.collectPublisherStats.bind(this, --attempts), this.RETRY_DELAY);
    }
    handleError(methodName, error, shouldWarn = true) {
        if (error.code === 1015) {
            if (shouldWarn) {
                this.$log.warn(`WebrtcConnectionStatsCollector:${methodName}`, error);
            }
        }
        else {
            throw error;
        }
    }
}
export default angular
    .module(`doxy.providers.video.common.services.${AngularServices.WebrtcConnectionStatsCollector}`, [])
    .service(AngularServices.WebrtcConnectionStatsCollector, WebrtcConnectionStatsCollector).name;
